<template>
  <div class="container" style="position: relative;">
    <HeaderOther />
    <main style="text-align: center; margin-top: 100px">
      <iframe frameborder="0" class="consult-iframe" src="https://www.jin10.com/example/jin10.com.html?fontSize=14px&theme=white"></iframe>
    </main>
    <Footer />
  </div>
</template>
<script >
import HeaderOther from '@/components/HeaderOther.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Consult',
  components: {
    HeaderOther,
    Footer
  },
  created () {
    this.handleSelectTab(1, '快讯')
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Consult.vue